(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dynamic-subscription-quiz"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {

  const state = {
    currentStep: 1,
    currentProduct: null,
    productCache: {},
    activeRequestId: 0,
    vipOn: document.querySelector('[data-vip-upsell]')?.dataset.vipDefault !== 'false'
  };

  function flashPrice(el) {
    el.classList.remove('price-flash');
    void el.offsetWidth;
    el.classList.add('price-flash');
  }

  let stepFiveConfettiFired = false;
  function fireStepFiveConfetti() {
    if (stepFiveConfettiFired) return;
    if (typeof confetti !== 'function') return;
    stepFiveConfettiFired = true;
    confetti({ particleCount: 18, spread: 55, origin: { x: 0.15, y: 0.5 }, colors: ['#3F89C9', '#FFD700', '#2fbaed'] });
    confetti({ particleCount: 18, spread: 55, origin: { x: 0.85, y: 0.5 }, colors: ['#3F89C9', '#FFD700', '#2fbaed'] });
  }

  const QUIZ_TRACKING_ENABLED = document.querySelector('[data-quiz-tracking]')?.dataset.quizTracking === 'true';
  const stepsTracked = new Set();
  function publishQuizStep(step) {
    if (!QUIZ_TRACKING_ENABLED || stepsTracked.has(step)) return;
    stepsTracked.add(step);
    if (typeof gtag === 'function') gtag('event', `quiz_step_${step}`);
  }
  function publishQuizStartedCheckout() {
    if (!QUIZ_TRACKING_ENABLED) return;
    if (typeof gtag === 'function') gtag('event', 'quiz_started_checkout');
  }

  const form = document.getElementById('subscription_form');
  const progressBar = document.getElementById('progressbar');
  const variantInput = document.getElementById('variant-id');
  const sellingPlanInput = document.getElementById('selling-plan-id');

  // ----------------------------
  // Helpers
  // ----------------------------
  const getSelectedOptions = () => ({
    optionOne: document.querySelector('input[name="option_one"]:checked')?.value,
    optionTwo: document.querySelector('input[name="option_two"]:checked')?.value,
    optionThree: document.querySelector('input[name="option_three"]:checked')?.value
  });

  const findVariant = (product, options) => {
    if (!product?.variants) return null;
    return product.variants.find(v =>
      v.option1 === options.optionOne &&
      v.option2 === options.optionTwo &&
      v.option3 === options.optionThree
    ) || null;
  };

  // Fetch once, cache forever — never called in hot paths after warmup
  const fetchProduct = async (handle) => {
    if (state.productCache[handle]) return state.productCache[handle];
    const res = await fetch(`/products/${handle}.json`);
    if (!res.ok) {
      const text = await res.text();
      console.error('PRODUCT FETCH FAILED', res.status, text.substring(0, 500));
      throw new Error(`Failed to fetch product: ${handle}`);
    }
    const data = await res.json();
    state.productCache[handle] = data.product;
    return data.product;
  };

  // ----------------------------
  // PREFETCH ALL PLAN PRODUCTS ON LOAD (one burst, then cache is warm)
  // ----------------------------
  async function prefetchAllPlanProducts() {
    const planHandles = [...document.querySelectorAll('input[name="product_plan"]')]
      .map(el => el.value)
      .filter(Boolean);

    // Deduplicate
    const uniqueHandles = [...new Set(planHandles)];

    try {
      await Promise.all(uniqueHandles.map(handle => fetchProduct(handle)));
      console.log('All plan products prefetched:', uniqueHandles);
    } catch (err) {
      console.error('Prefetch error:', err);
    }
  }

  // ----------------------------
  // Quiz Results Injection
  // ----------------------------
  function injectQuizResults() {
    const { optionOne, optionTwo } = getSelectedOptions();
    const didYouKnowEl = document.getElementById('did-you-know-copy');

    const chewRadios = [...document.querySelectorAll('input[name="option_two"]')];
    const selectedIndex = chewRadios.findIndex(r => r.value === optionTwo);

    const didYouKnowMessages = [
      `Gentle chewers can enjoy softer toys, extra enrichment, and longer-lasting fun.`,
      `Moderate chewers love a little bit of everything, so we picked the perfect mix of fun, enrichment, and durability.`,
      `Tough chewers put every toy to the test, so we loaded this box with our most durable picks yet.`
    ];

    if (didYouKnowEl) didYouKnowEl.innerHTML = didYouKnowMessages[selectedIndex] || "";
  }

  // ----------------------------
  // Progress Bar
  // ----------------------------
  function updateProgressBar(step) {
    document.querySelectorAll('#progressbar .step').forEach((stepElem, index) => {
      stepElem.classList.toggle('active', index < step);
    });
  }
  function updateStepActiveState(step) {
    document.querySelectorAll('#progressbar .step').forEach(stepElem => {
      const stepIndex = parseInt(stepElem.getAttribute('data-step'), 10);
      stepElem.classList.toggle('active', stepIndex <= step);
      stepElem.classList.toggle('current', stepIndex === step);
    });
  }
  function initializeProgressBar() {
    updateProgressBar(state.currentStep);
    updateStepActiveState(state.currentStep);
  }
  if (progressBar) initializeProgressBar();

  // ----------------------------
  // VIP TOGGLE
  // ----------------------------
  const vipToggleWrap = document.querySelector('[data-vip-toggle-wrap]');
  const vipToggleEl = document.querySelector('[data-vip-toggle]');
  const vipToggleLbl = document.querySelector('[data-vip-toggle-label]');

  if (vipToggleWrap) {
    vipToggleWrap.addEventListener('click', function(e) {
      e.stopPropagation();
      state.vipOn = !state.vipOn;
      vipToggleWrap.setAttribute('aria-pressed', state.vipOn ? 'true' : 'false');
      if (state.vipOn) {
        vipToggleEl.classList.add('vip-toggle--on');
        vipToggleLbl.textContent = 'Added ✓';
        document.querySelector('.vip-upsell-block')?.classList.remove('vip-off');
      } else {
        vipToggleEl.classList.remove('vip-toggle--on');
        vipToggleLbl.textContent = 'Add it?';
        document.querySelector('.vip-upsell-block')?.classList.add('vip-off');
      }
      // Fully sync now — cache is warm
      updateAllPlanPrices();
      updateCTAPrice();
      const vipPlanOption = document.querySelector('[data-vip-upsell]')?.closest('.radio_option');
      if (vipPlanOption) {
        vipPlanOption.querySelectorAll('.subscription-discounted-price, .subscription-price-compare').forEach(el => flashPrice(el));
      }
    });
  }

  // ----------------------------
  // Fieldset Navigation
  // ----------------------------
  function navigateFieldset(forward = true) {
    const currentFs = document.querySelector(`fieldset:nth-of-type(${state.currentStep})`);
    const nextFs = forward ? currentFs?.nextElementSibling : currentFs?.previousElementSibling;
    if (!currentFs || !nextFs) return;

    currentFs.style.display = 'none';
    nextFs.style.display = 'block';

    if (state.currentStep === 4 && forward) {
      const animatedBlocks = nextFs.querySelectorAll('.fieldstep-inner, .subscription_product');
      animatedBlocks.forEach(block => {
        block.style.opacity = '0';
        block.style.transform = 'translateY(15px)';
        block.style.transition = 'none';
      });
      requestAnimationFrame(() => {
        animatedBlocks.forEach(block => {
          block.style.transition = 'opacity .6s ease, transform .6s ease';
          block.style.opacity = '1';
          block.style.transform = 'translateY(0)';
        });
      });
    }

    state.currentStep = forward ? state.currentStep + 1 : state.currentStep - 1;
    publishQuizStep(state.currentStep);
    updateProgressBar(state.currentStep);
    updateStepActiveState(state.currentStep);

    document.querySelectorAll('.hide-on-step-5').forEach(el => {
      el.classList.toggle('hidden-all', state.currentStep === 5);
    });

    if (state.currentStep === 5) {
      fireStepFiveConfetti();
      injectQuizResults();
      // Cache is warm by now — this is fully sync
      updateAllPlanPrices();
      updateCTAPrice();
    }

    document.body.offsetHeight;
    jQuery("html, body").animate({ scrollTop: 0 }, 500);
  }

  document.querySelectorAll('.next').forEach(btn => btn.addEventListener('click', () => navigateFieldset(true)));
  document.querySelectorAll('.previous').forEach(btn => btn.addEventListener('click', () => navigateFieldset(false)));

  // ----------------------------
  // Core Updates — all sync after warmup
  // ----------------------------
  function updateQuizVariants() {
    if (!state.currentProduct?.variants) return;
    const options = getSelectedOptions();
    if (!options.optionOne || !options.optionTwo || !options.optionThree) return;
    const matchedVariant = findVariant(state.currentProduct, options);
    if (matchedVariant) variantInput.value = matchedVariant.id;
  }

  // SYNC — reads from cache only, no fetches
  function updateAllPlanPrices() {
    const options = getSelectedOptions();
    if (!options.optionOne || !options.optionTwo || !options.optionThree) return;

    const plans = document.querySelectorAll('input[name="product_plan"]');
    const lastPlan = plans[plans.length - 1];
    const monthlyProduct = state.productCache[lastPlan?.value];
    const monthlyVariant = monthlyProduct ? findVariant(monthlyProduct, options) : null;

    plans.forEach(plan => {
      const productHandle = plan.value;
      const product = state.productCache[productHandle];
      if (!product) return; // not cached yet, skip silently

      const matchedVariant = findVariant(product, options);
      if (!matchedVariant) return;

      document.querySelectorAll(`.radio_option[data-product-handle="${productHandle}"]`).forEach(option => {
        const originalPriceEl = option.querySelector('.subscription-price');
        const comparePriceEl = option.querySelector('.subscription-price-compare');
        const discountedPriceEl = option.querySelector('.subscription-discounted-price');
        const discountPercentage = parseInt(option.getAttribute('data-discount'), 10);

let vipPrice = 0;
let vipOriginalPrice = 0;
const vipBlock = option.querySelector('[data-vip-upsell]');
if (vipBlock && state.vipOn) {
  vipPrice = parseFloat(vipBlock.getAttribute('data-vip-price')) || 0;
  vipOriginalPrice = parseFloat(vipBlock.getAttribute('data-vip-original-price')) || 0;
}

if (originalPriceEl) originalPriceEl.textContent = `$${parseFloat(matchedVariant.price).toFixed(2)}`;

if (comparePriceEl && monthlyVariant) {
  const bonusValue = (parseFloat(option.getAttribute('data-bonus-value')) || 0) / 100;
  const comparePrice = parseFloat(monthlyVariant.price) + vipOriginalPrice + bonusValue;
  comparePriceEl.textContent = `$${comparePrice.toFixed(2)}`;
  comparePriceEl.style.display = (plan === lastPlan) ? 'none' : '';
}

if (discountedPriceEl) {
  const pct = discountPercentage || 0;
  const discountedPrice = (matchedVariant.price * (1 - pct / 100)) + vipPrice;
  discountedPriceEl.textContent = `$${discountedPrice.toFixed(2)}`;
}

      });
    });
  }

  function updateSellingPlan() {
    const selectedPlan = document.querySelector('input[name="product_plan"]:checked');
    if (selectedPlan) sellingPlanInput.value = selectedPlan.getAttribute('data-plan-id') || '';
  }

  function updateCTAPrice() {
    const ctaTag = document.getElementById('cta-price-tag');
    const selectedOption = document.querySelector('input[name="product_plan"]:checked')?.closest('.radio_option');
    if (!ctaTag || !selectedOption) return;
    const base = parseFloat(
      (selectedOption.querySelector('.subscription-discounted-price') || selectedOption.querySelector('.subscription-price'))
        ?.textContent?.replace('$', '')
    );
    if (isNaN(base)) return;
    ctaTag.textContent = `· $${base.toFixed(2)}`;
  }

  // Still async — but only called once per plan switch, and returns from cache immediately after warmup
  async function loadProductData(productHandle) {
    const requestId = ++state.activeRequestId;
    try {
      const product = await fetchProduct(productHandle); // instant if cached
      if (requestId !== state.activeRequestId) return;
      state.currentProduct = product;
      updateQuizVariants();
      updateAllPlanPrices();
    } catch (error) {
      console.error('Error loading product data:', error);
    }
  }

  // ----------------------------
  // Checkout
  // ----------------------------
  let isSubmitting = false;
  const checkoutBtn = document.querySelector('.add-box-btn');

  function startOverlaySequence(petName) {
    const statusEl = document.getElementById('quiz-loading-status');
    const progressEl = document.querySelector('.quiz-loading-progress-inner');
    if (!statusEl || !progressEl) return;
    progressEl.style.transition = 'width 0.6s ease';
    progressEl.style.width = '0%';
    void progressEl.offsetWidth;
    statusEl.textContent = 'Matching size…';
    statusEl.style.opacity = '0.9';
    progressEl.style.width = '35%';
    setTimeout(() => {
      statusEl.style.opacity = '0';
      setTimeout(() => {
        statusEl.textContent = `Picking toys just for ${petName}…`;
        statusEl.style.opacity = '0.9';
      }, 150);
      progressEl.style.width = '85%';
    }, 800);
  }

  function completeProgress() {
    const progressEl = document.querySelector('.quiz-loading-progress-inner');
    if (progressEl) progressEl.style.width = '100%';
  }

  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', async () => {
      if (isSubmitting) return;
      isSubmitting = true;
      checkoutBtn.disabled = true;

      const overlay = document.getElementById('quiz-loading-overlay');
      const overlayStartTime = Date.now();
      const petName = document.querySelector('.dogName-full')?.textContent || "Your Dog";

      if (overlay) {
        const overlayName = document.getElementById('overlay-dog-name');
        if (overlayName) overlayName.textContent = petName;
        overlay.classList.add('active');
        startOverlaySequence(petName);
      }

      updateQuizVariants();
      updateSellingPlan();

      const variantId = Number(variantInput?.value);
      const sellingPlanId = Number(sellingPlanInput?.value);

      if (!variantId || !sellingPlanId) {
        if (overlay) overlay.classList.remove('active');
        checkoutBtn.disabled = false;
        isSubmitting = false;
        alert('Please complete all quiz steps before submitting.');
        return;
      }

      publishQuizStartedCheckout();

      try {
        // Fetch cart once
        const cartRes = await fetch('/cart.js');
        if (!cartRes.ok) throw new Error('Failed to fetch cart');
        const cart = await cartRes.json();

        const quizBundleItems = cart.items.filter(item => item.properties?._quiz_bundle_id);
        if (quizBundleItems.length > 0) {
          const updates = {};
          quizBundleItems.forEach(item => { updates[item.key] = 0; });
          const updateRes = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
          });
          if (!updateRes.ok) throw new Error('Failed removing existing quiz bundle');
        }

        await new Promise(resolve => setTimeout(resolve, 250));

        const selectedPlan = document.querySelector('input[name="product_plan"]:checked');
        let bonusVariants = [];
        if (selectedPlan) {
          const selectedOption = selectedPlan.closest('.radio_option');
          if (selectedOption?.dataset.bonusVariants) {
            try {
              const parsed = JSON.parse(selectedOption.dataset.bonusVariants);
              if (Array.isArray(parsed)) bonusVariants = [...new Set(parsed)];
            } catch (e) { console.warn('Invalid bonusVariants JSON'); }
          }
        }

        const rawName = document.querySelector('#dog-name')?.value?.trim();
        const birthdayValue = document.getElementById('birthday')?.value?.trim();
        const properties = {};
        if (rawName) properties.Name = rawName;
        if (birthdayValue) properties.Birthday = birthdayValue;

        const bundleId = `bundle_${Date.now()}_${Math.random().toString(36).slice(2,8)}`;

        const items = [{
          id: variantId,
          quantity: 1,
          selling_plan: sellingPlanId,
          properties: { ...properties, _quiz_bundle_id: bundleId, _bundle_parent: 'true' }
        }];

        bonusVariants.forEach(bonusId => {
          if (bonusId && !isNaN(bonusId)) {
            items.push({ id: Number(bonusId), quantity: 1, properties: { _quiz_bundle_id: bundleId, _free_gift: "true" } });
          }
        });

        // VIP — use cache, no fetch
        if (state.vipOn) {
          const selectedPlanOption = document.querySelector('input[name="product_plan"]:checked')?.closest('.radio_option');
          const vipUpsellBlock = selectedPlanOption?.querySelector('[data-vip-upsell]');
          if (vipUpsellBlock) {
            const vipHandle = vipUpsellBlock.getAttribute('data-handle');
            const vipPlan = vipUpsellBlock.getAttribute('data-selling-plan');
            const chewValue = document.querySelector('input[name="option_two"]:checked')?.value;
            const vipProduct = state.productCache[vipHandle] || await fetchProduct(vipHandle);
            const vipVariant = vipProduct?.variants?.find(v => v.title === chewValue);
            if (vipVariant) {
              items.push({
                id: Number(vipVariant.id),
                quantity: 1,
                selling_plan: Number(vipPlan),
                properties: { _quiz_bundle_id: bundleId, _vip_addon: 'true' }
              });
            }
          }
        }

        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [...items].reverse() })
        });

        if (!addRes.ok) {
          const errBody = await addRes.text();
          console.error('Cart add failed — Shopify response:', errBody);
          throw new Error(`Cart add failed: ${addRes.status}`);
        }

        completeProgress();
        const minDisplayTime = 2000;
        const elapsed = Date.now() - overlayStartTime;
        setTimeout(() => { window.location.href = '/checkout'; }, Math.max(minDisplayTime - elapsed, 0));

      } catch (error) {
        console.error('Checkout error:', error);
        if (overlay) overlay.classList.remove('active');
        checkoutBtn.disabled = false;
        isSubmitting = false;
        alert('Something went wrong. Please try again.');
      }
    });
  }

  // ----------------------------
  // Plan Change
  // ----------------------------
  document.querySelectorAll('input[name="product_plan"]').forEach(plan => {
    plan.addEventListener('change', async () => {
      const productHandle = plan.value;
      // Product is already cached from prefetch — loadProductData returns instantly
      await loadProductData(productHandle);
      updateSellingPlan();
      updateCTAPrice();
    });
  });

  // ----------------------------
  // Radio Active Styling
  // ----------------------------
  document.querySelectorAll('input[type="radio"]').forEach(radio => {
    radio.addEventListener('change', () => {
      const parentOption = radio.closest('.radio_option');
      if (parentOption?.parentElement) {
        parentOption.parentElement.querySelectorAll('.radio_option').forEach(o => o.classList.remove('active'));
        parentOption.classList.add('active');
      }
      updateQuizVariants();
      updateAllPlanPrices(); // sync, no fetch
    });
  });

  // ----------------------------
  // Dog Name Injection
  // ----------------------------
  function formatDogNames(rawName) {
    if (!rawName || rawName === "Your Dog") return { full: "Your Dog", short: "Your Dog" };
    const trimmed = rawName.trim();
    let shortName = trimmed;
    if (trimmed.toLowerCase().includes(" and ")) {
      shortName = trimmed.split(/ and /i)[0].trim();
    } else {
      const parts = trimmed.split(" ");
      if (parts.length > 1) shortName = parts[0];
    }
    if (shortName.length > 12) shortName = shortName.substring(0, 12);
    return { full: trimmed, short: shortName };
  }

  function injectDogNames() {
    const input = document.querySelector('#dog-name');
    const rawName = input?.value?.trim() || "Your Dog";
    const names = formatDogNames(rawName);
    document.querySelectorAll('.dogName-full').forEach(el => { el.textContent = names.full; });
    document.querySelectorAll('.dogName-short').forEach(el => { el.textContent = names.short; });
  }

  const dogNameInput = document.querySelector('#dog-name');
  if (dogNameInput) {
    dogNameInput.addEventListener('input', injectDogNames);
    injectDogNames();
  }

  // ----------------------------
  // is-filled logic
  // ----------------------------
  document.querySelectorAll('select.input__field').forEach(select => {
    if (select.value) select.classList.add('is-filled');
    select.addEventListener('change', function () { select.classList.toggle('is-filled', select.value !== ""); });
  });
  document.querySelectorAll('input.input__field').forEach(input => {
    if (input.value) input.classList.add('is-filled');
    input.addEventListener('keyup', function () { input.classList.toggle('is-filled', input.value !== ""); });
  });

  // ----------------------------
  // Dynamic Messages
  // ----------------------------
  function updateMessage(selectedValue, type) {
    const messageBoxes = { chew: "chewMessage", box: "boxMessage" };
    const messages = {
      chew: {
        "Light Chewer": "Soft plush & squeaky toys for gentle play.",
        "Moderate Chewer": "The perfect balance of fun and durability.",
        "Tough Chewer": "Built for serious chewers. Ultra-durable rubber & nylon."
      },
      box: {
        "Toys & Treats": "💙 100% Canadian-made treats with simple, clean ingredients your dog will love.",
        "Toys Only": "🐾 No treats? No problem! We've packed in extra toys instead!"
      }
    };
    const messageBox = document.getElementById(messageBoxes[type]);
    if (!messageBox) return;
    messageBox.classList.add("fade");
    setTimeout(() => {
      messageBox.innerHTML = messages[type][selectedValue] || "";
      messageBox.classList.remove("fade");
    }, 200);
  }

  const defaultChew = document.querySelector("input[name='option_two']:checked");
  const defaultBox = document.querySelector("input[name='option_three']:checked");
  if (defaultChew) updateMessage(defaultChew.value, "chew");
  if (defaultBox) updateMessage(defaultBox.value, "box");

  document.querySelectorAll("input[name='option_two']").forEach(radio => {
    radio.addEventListener("change", function () { updateMessage(this.value, "chew"); });
  });
  document.querySelectorAll("input[name='option_three']").forEach(radio => {
    radio.addEventListener("change", function () { updateMessage(this.value, "box"); });
  });

  // ----------------------------
  // INIT — prefetch everything first, then set up state
  // ----------------------------
  prefetchAllPlanProducts().then(() => {
    const initialPlan = document.querySelector('input[name="product_plan"]:checked');
    if (initialPlan) {
      state.currentProduct = state.productCache[initialPlan.value] || null;
      updateSellingPlan();
      updateQuizVariants();
      // Prices will update when user hits step 5
    }
  });

  setTimeout(() => { publishQuizStep(state.currentStep); }, 400);
});

  } catch(e) { console.error(e); }
})();
})();
